import r from"graphql-tag";import{CircleSeriesFragmentDoc as s,CircleTopicFragmentDoc as u,CircleTopicBaseFragmentDoc as l,CircleRsvpQuestionFragmentDoc as a,CircleFacilitatorFragmentDoc as S,CircleTopicSessionFragmentDoc as m}from"./fragments.generated.es.js";import*as t from"@apollo/react-hooks";const i={},c=r`
    query fetchSeries {
  circleSeriesCollection {
    totalCount
    items {
      ...CircleSeries
    }
  }
}
    ${s}`;function C(e){const o={...i,...e};return t.useQuery(c,o)}function F(e){const o={...i,...e};return t.useLazyQuery(c,o)}const n=r`
    query fetchSeriesWithSessions {
  circleSeriesCollection {
    totalCount
    items {
      ...CircleSeries
      topics {
        totalCount
        edges {
          cursor
          node {
            id
            ...CircleTopic
          }
        }
      }
    }
  }
}
    ${s}
${u}
${l}
${a}
${S}
${m}`;function h(e){const o={...i,...e};return t.useQuery(n,o)}function f(e){const o={...i,...e};return t.useLazyQuery(n,o)}export{c as FetchSeriesDocument,n as FetchSeriesWithSessionsDocument,F as useFetchSeriesLazyQuery,C as useFetchSeriesQuery,f as useFetchSeriesWithSessionsLazyQuery,h as useFetchSeriesWithSessionsQuery};
//# sourceMappingURL=series.generated.es.js.map
